import { Component, OnInit } from '@angular/core';
import { UsersService } from '../../../Services/users.service';
import { CheckAuth } from '../../../Services/utility.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserModel } from '../../../Models/usersModel';
import { Title } from '@angular/platform-browser';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  userModel = new UserModel();
  appModel: any;
  tokenKey: string = '';
  loginForm: FormGroup;
  multipleEmail: boolean = false;
  userName: string = null;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;

  constructor(private readonly checkAuth: CheckAuth,
    private readonly _fb: FormBuilder,
    private readonly toastr: ToastrService,
    private readonly usersService: UsersService,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
    sessionStorage.removeItem('tokenValue');
    sessionStorage.removeItem('appStartTime');
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    sessionStorage.removeItem('isAdminOpen');
    sessionStorage.removeItem('AdminUserId');
    sessionStorage.removeItem('StateSetupManageRedirection');
    this.titleService.setTitle('Forgot Password | JSi360');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.loginForm = this._fb.group({
      userid: 0,
      email: ['', [Validators.required]],
      userName: ['', [Validators.required]],
    })
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  CheckUser(loginForm: any) {

    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (loginForm.value["email"] == "") {
      this.showMessage('Please enter email', 'Error', 'error');
      return;
    }

    if(this.multipleEmail){
      if (loginForm.value["userName"] == "") {
        this.showMessage('Please enter user name', 'Error', 'error');
        return;
      }
    }

    if (loginForm.value['email'].trim() != '') {
      let result = this.isValidMailFormat(loginForm.controls.email);
      if (result != null) {
        this.showMessage('Please provide a valid email', 'Invalid Email', 'error');
        return;
      }
    }

    if (loginForm.value['userName'].trim() != '') {
      this.userName = loginForm.value['userName'].trim();
    }
    this.blockDocument();
    this.usersService.CheckUserByEmailIdCount(this.tokenKey, loginForm.value['email'].trim()).subscribe(
      data => {
        this.unblockDocument();
        if (data["status"] == "Success") {
          if (data["emailCount"] == 1 || this.multipleEmail) {
            this.blockDocument();
            this.usersService.CheckUserByEmailId(this.tokenKey, loginForm.value['email'].trim(), this.userName).subscribe(
              data => {
                this.unblockDocument();
                if (data["status"] == "Success") {
                  this.showMessage('Please check you inbox, Email sent successfully on ' + loginForm.value['email'].trim(), 'Success', 'success');
                  this.loginForm.setValue({
                    userid: 0,
                    email: [''],
                  })

                }
                else {
                  this.showMessage(data["status"], 'Error', 'error');
                }
              },
              error => {
                this.unblockDocument();
                this.showMessage(error, 'Error', 'error');
              }
            );
          }
          else {
            if(data["emailCount"] == 0)
              {
                this.showMessage(data["status"], 'Error', 'error');
              }
              else{
                this.multipleEmail = true;
                this.showMessage('Multiple email found please enter user name!', 'Warning', 'warning');
              }
          }
        } else {
          this.showMessage(data["status"], 'Error', 'error');
        }
      },
      error => {
        this.unblockDocument();
        this.showMessage(error, 'Error', 'error');
      });
  }

  isValidMailFormat(control: FormControl) {
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    if (control.value != '' && (control.value.length <= 5 || !EMAIL_REGEXP.test(control.value))) {
      return { 'Please provide a valid email': true };
    }

    return null;
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
}
